function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useGlobalContext } from 'seagull';
import { ConfirmationModal } from 'seagull';
import { useDuplicateRelationship } from "./useDuplicateRelationship";
import { useStoreActions } from "../contexts";
import { ErrorText } from "../constants";
import { ErrorResponse, ServerError } from "../infra/ErrorResponse";
export function useWithdrawToEditProposal() {
  const globalContext = useGlobalContext();
  const {
    duplicateRelationshipAndRedirect,
    duplicateRelationship
  } = useDuplicateRelationship();
  const {
    api
  } = useStoreActions();
  async function approveWithdrawProposal(action, errorMessage, modalProps) {
    const confirmed = await globalContext.showModal({
      closeOnClickOutside: true,
      shouldBlurBackground: true,
      closeOnEscapeKey: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/React.createElement(ConfirmationModal, _extends({
          skin: "danger"
        }, modalProps, {
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false)
        }));
      }
    });
    if (confirmed) {
      try {
        await action();
      } catch (err) {
        globalContext.showErrorToast(errorMessage);
      }
    }
  }
  async function cancelProposal(id) {
    try {
      await api.relationship.cancelProposal(id);
    } catch (err) {
      if (new ErrorResponse(err).hasServerError(ServerError.InvalidRelationshipStatus)) {
        globalContext.showErrorToast(ErrorText.ProposalAlreadyAcceptedOrCanceled);
      }
      throw err;
    }
  }
  async function withdrawToEditAndRedirect(id) {
    await duplicateRelationshipAndRedirect(id, 'withdraw-to-edit');
    await cancelProposal(id);
  }
  return {
    withdrawToEditProposalByIdWithConfirmation: async id => {
      return approveWithdrawProposal(() => withdrawToEditAndRedirect(id), 'Failed to withdraw proposal for editing', {
        title: 'Withdraw to edit',
        content: 'Once you withdraw this proposal, the client’s previous link will be disabled. As soon as you send the new proposal, an email will be sent with a link to the new version.',
        primaryButtonLabel: 'Withdraw and edit',
        secondaryButtonLabel: 'Cancel'
      });
    },
    withdrawToEditProposalById: async id => {
      await duplicateRelationship(id, 'withdraw-to-edit');
      await cancelProposal(id);
    }
  };
}